import { Image } from '$partials/media';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */
/**
 * @type {import('$types/components/partials/modules.d.ts').TwoImages}
 */
const TwoImages = ({
    image1,
    image2,
    video1,
    video2,
    caption1,
    caption2
}) => {
    return (
        <div>
            {/* images */}
            <div className='col-12 flex flex-wrap items-end justify-between'>
                <div className='col-12 sm-col-6 md-col-5 mb7 sm-mb0 sm-pr9 md-pr6'>
                    <figure>
                        <div>
                            {video1 ? (
                                <video
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    src={video1.videoUrl}/>
                            ) : (
                                <Image {...image1} />
                            )}
                        </div>
                    </figure>
                    {caption1 &&
                        <figcaption className='sm-hide mt4'>
                            <div
                                className='rich-text type-style-7'
                                dangerouslySetInnerHTML={{__html: caption1}}/>
                        </figcaption>
                    }
                </div>
                <div className='col-12 sm-col-4 md-pl7'>
                    <figure>
                        <div>
                            {video2 ? (
                                <video
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    src={video2.videoUrl}/>
                            ) : (
                                <Image {...image2} />
                            )}
                        </div>
                    </figure>
                    {caption2 &&
                        <figcaption className='sm-hide mt4'>
                            <div
                                className='rich-text type-style-7'
                                dangerouslySetInnerHTML={{__html: caption2}}/>
                        </figcaption>
                    }
                </div>
            </div>

            {/* desktop/tablet captions */}
            <div className='hide sm-show'>
                <div className='col-12 flex items-end justify-between'>
                    <div className='col-6 md-col-4 pr9 md-pr6'>
                        {caption1 &&
                        <figcaption className='pt4'>
                            <div
                                className='rich-text type-style-7'
                                dangerouslySetInnerHTML={{__html: caption1}}/>
                        </figcaption>
                        }
                    </div>
                    <div className='col-4 md-col-4 md-pl7'>
                        {caption2 &&
                        <figcaption className='pt4'>
                            <div
                                className='rich-text type-style-7'
                                dangerouslySetInnerHTML={{__html: caption2}}/>
                        </figcaption>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default TwoImages;
